const routes = {
  //#region SCREENS
  signIn: '/signIn',
  organizer: '/organizer',
  places: '/places',
  events: '/events',
  notFound: '*',

  //#region PLACES
  getAllPlaces: '/places/all',
  getPlace: '/places/details',
  createPlace: '/places/create',
  editPlace: '/places/edit',
  deletePlace: '/places/delete',
  approvePlaces: '/places/approve',

  //#region BUSINESS
  approveBusiness: '/business/approve',

  //#region EVENTS
  getAllEvents: '/events/all',
  getEvent: '/events/details',
  createEvent: '/events/create',
  editEvent: '/events/edit',
  deleteEvent: '/events/delete',

  //#region ACTIVITIES
  activities: '/activities',

  //#region USERS
  users: '/users',

  //#region SUPPORT
  support: '/support',

  //#region CATALOG
  cities: '/cities',
  tags: '/tags',
  tokens: '/tokens',
  challenges: '/challenges',

  //#region TAGS
  tagSelection: '/tagSelection',
};
export default routes;
